// Darstellung der Kurssets im UI.
//
// Die Liste der gültigen Kurssets ist bewusst NICHT hier hinterlegt –
// sie kommt über `api.listTotaraCourseSets()` aus dem Backend
// (`backend/src/courseSets.js`), das auch die Validierung übernimmt.
// So gibt es genau eine Quelle der Wahrheit.

/**
 * Beschriftung eines Kurssets. "Standard" ist kein Eigenname, sondern
 * die Sammelgruppe aller Mandanten ohne eigenes Kursset – im UI daher
 * als "Standardmandanten" ausgeschrieben.
 */
export function courseSetLabel(courseSet) {
    if (!courseSet) return '';
    return courseSet === 'Standard' ? 'Standardmandanten' : courseSet;
}
